import {createSelector} from '@reduxjs/toolkit';
import {FeatureToggle} from '../../data/entities';
import {RootState} from '../../rootReducer';
import {isOccupancyEnabled} from './helpers';

export const getEnabledFeaturesLoadingStatus = (state: RootState) => state.data.features.enabledFeaturesLoadingStatus;

export const getEnabledFeatures = (state: RootState) => state.data.features.enabledFeatures;

export const getIsEnabledFeaturesInitialized = (state: RootState) => state.data.features.isInitialized;

export const getIsFeatureEnabled = createSelector(
  getEnabledFeatures,
  (_: RootState, feature: FeatureToggle) => feature,
  (enabledFeatures, feature) => enabledFeatures.includes(feature),
);

export const getIsHybridMeetingsFeatureEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.HybridMeetingsCalendarView),
);

export const getIsCheckInFeatureEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.CheckIn),
);

export const getIsManualCheckInFeatureEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.ManualCheckIn),
);

export const getIsProfilePicturesFeatureEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.ProfilePictures),
);

export const getIsParkingFeatureEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.Parking),
);

export const getIsOccupancyEnabled = createSelector(getEnabledFeatures, isOccupancyEnabled);

export const getIsExtrasFeatureEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.ExtrasFeature),
);

export const getIsWorkspacesOnHereAndNowEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.WorkspacesOnHereAndNow),
);

export const getIsThreeDMapsEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.ThreeDMaps),
);
export const getIsThreeDMapsAsDefaultEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.ThreeDMapsAsDefault),
);

export const getIsOnboardingResetEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.OnboardingReset),
);

// Temporary
export const getIsMapsUsabilityVariantsEnabled = createSelector(getEnabledFeatures, (enabledFeatures) =>
  enabledFeatures.includes(FeatureToggle.MapsUsabilityVariants),
);
